<app-card-content [icon]="'pi pi-compass'" [title]="labelMetaSolicitacao" [subtitle]="valorMetaSolicitacao" [border]="false">
    @if (mostrarVoltar() || exibirAcoes()) {
        <div card-header class="flex items-center gap-2">
            @if (mostrarVoltar()) {
                <button pButton type="button" icon="pi pi-arrow-left" label="Voltar" class="p-button-text p-button-sm" (click)="voltar.emit()"></button>
            }
            @if (exibirAcoes()) {
                <app-botao-acoes label="A&ccedil;&otilde;es" [iconPos]="EInconPos.LEFT" [items]="itensAcoesMenu()" [iconColumns]="2"></app-botao-acoes>
            }
        </div>
    }

    <div class="px-3 pt-2 pb-3">
        <div class="servico-central-info">
            @if (erroConfirmacaoSolicitacao(); as recusaDaFinalizacao) {
                <!--
                    Mesmo lugar e mesma vida do banner do CRM, e pelo mesmo motivo: o dialogo de acao
                    ja fechou quando a resposta do backend chega. `role="alert"` porque isto interrompe
                    o que o analista estava fazendo — o ato que ele acabou de autorizar NAO ocorreu.
                    So some quando ele tenta de novo ou abre outro protocolo, nunca sozinho.
                -->
                <div class="historico-feedback erro recusa-finalizacao-feedback" role="alert">{{ recusaDaFinalizacao }}</div>
            }

            @if (crmGeradoConfirmacao() !== null) {
                <!--
                    FORA do dialogo de acao, de proposito: `confirmarDialogAcao()` fecha o dialogo no
                    MESMO clique — sincrono —, e a resposta do backend (com o CRM) chega segundos
                    depois, quando o `@if` do dialogo ja e falso. Aqui a exibicao depende so do sinal
                    do CRM: sobrevive ao fechamento do dialogo e a troca de aba, e so desaparece
                    quando o analista sai deste protocolo (seleciona outro, volta a lista) — nunca por
                    conta propria, porque o numero e um dado que ele ainda vai copiar e anotar.
                -->
                <div class="historico-feedback sucesso crm-gerado-feedback" role="status">
                    @if (sucessoConfirmacaoSolicitacao()) {
                        <p>{{ sucessoConfirmacaoSolicitacao() }}</p>
                    }
                    <p>
                        CRM gerado: <strong>{{ crmGeradoConfirmacao() }}</strong>
                    </p>
                </div>
            }

            @if (activeAction() === 'historico') {
                <section class="historico-tramitacoes">
                    <header class="historico-header">
                        <div class="historico-header-info">
                            <h3>Hist&oacute;rico de Tramita&ccedil;&otilde;es</h3>
                            <!--                            @if (protocoloSelecionado?.portal) {-->
                            <!--                                <span class="historico-protocolo">Protocolo: {{ protocoloSelecionado?.portal }}</span>-->
                            <!--                            }-->
                        </div>
                        <button pButton type="button" icon="pi pi-plus" class="p-button-sm" label="Inserir histórico" (click)="abrirDialogHistorico()"></button>
                    </header>

                    @if (erroInsercaoHistorico()) {
                        <div class="historico-feedback erro">{{ erroInsercaoHistorico() }}</div>
                    }

                    @if (carregandoHistorico()) {
                        <div class="historico-feedback">Carregando tramitações...</div>
                    } @else if (erroHistorico()) {
                        <div class="historico-feedback erro">{{ erroHistorico() }}</div>
                    } @else if (!historicoTramitacoes().length) {
                        <div class="historico-feedback">Nenhuma tramitação encontrada para este protocolo.</div>
                    } @else {
                        <div class="historico-cards">
                            @for (tramitacao of historicoTramitacoes(); track $index) {
                                <article class="historico-card">
                                    <div class="historico-card-topo">
                                        <strong>{{ formatarDataTramitacao(tramitacao.dataTramitacao) }}</strong>
                                        @if (tramitacao.ufProtocolo) {
                                            <span class="historico-uf">{{ tramitacao.ufProtocolo }}</span>
                                        }
                                    </div>

                                    @if (tramitacao.textoInformativo) {
                                        <p>{{ tramitacao.textoInformativo }}</p>
                                    } @else {
                                        <p>Sem texto informativo.</p>
                                    }
                                </article>
                            }
                        </div>
                    }
                </section>
            }

            <p-dialog
                appDialogoPadrao="pi pi-history"
                descricao="Registre o andamento do protocolo."
                [visible]="exibirDialogHistorico()"
                (visibleChange)="exibirDialogHistorico.set($event)"
                [style]="{ width: '42rem', maxWidth: '95vw' }"
                styleClass="card-servicos-historico-dialog"
                header="Inserir histórico de tramitação"
                (onHide)="cancelarNovoHistorico()"
            >
                <section class="historico-formulario dialog">
                    <label for="novo-historico-texto">Texto da tramitação</label>
                    <textarea id="novo-historico-texto" rows="6" [value]="novoHistoricoTexto()" [disabled]="inserindoHistorico()" placeholder="Descreva a nova tramitação" (input)="atualizarTextoHistorico($event)"></textarea>
                </section>

                <ng-template pTemplate="footer">
                    <div class="historico-formulario-acoes">
                        <button pButton type="button" class="p-button-text p-button-sm" label="Cancelar" [disabled]="inserindoHistorico()" (click)="cancelarNovoHistorico()"></button>
                        <button pButton type="button" icon="pi pi-save" class="p-button-sm" label="Salvar histórico" [loading]="inserindoHistorico()" [disabled]="!novoHistoricoTexto().trim()" (click)="salvarNovoHistorico()"></button>
                    </div>
                </ng-template>
            </p-dialog>

            <p-dialog
                appDialogoPadrao="pi pi-briefcase"
                descricao="Ação sobre o protocolo selecionado."
                [visible]="exibirDialogAcao()"
                (visibleChange)="exibirDialogAcao.set($event)"
                [style]="{ width: '30rem', maxWidth: '92vw' }"
                styleClass="card-servicos-acao-dialog"
                [header]="tituloDialogAcao()"
                (onHide)="fecharDialogAcao()"
            >
                <p class="dialog-acao-mensagem">{{ mensagemDialogAcao() }}</p>
                @if (isConfirmacaoComData()) {
                    <section class="historico-formulario dialog">
                        <label for="data-cancelamento-falecimento">{{
                            selectedCodigo() === 'regimento-interno' || selectedCodigo() === 'regimento-interno-corpo-clinico'
                                ? 'Data da homologacao'
                                : selectedCodigo() === 'solicitacao-diretor' || selectedCodigo() === 'diretor-tecnico-solicitacao-pj' || selectedCodigo() === 'solicitacao-diretor-tecnico' || selectedCodigo() === 'diretor-tecnico-solicitacao-pf'
                                  ? 'Data da diretoria'
                                  : 'Data do cancelamento'
                        }}</label>
                        <input id="data-cancelamento-falecimento" type="date" [ngModel]="dataCancelamentoFalecimento()" (ngModelChange)="dataCancelamentoFalecimento.set($event)" />
                    </section>
                }
                @if (dialogAcaoSelecionada() === 'confirmar' && isConfirmacaoAlteracaoCadastral()) {
                    <section class="historico-formulario dialog">
                        <label for="observacao-efetivacao">Observação da efetivação</label>
                        <!-- 4000, o mesmo limite das outras duas portas do MESMO campo (o diálogo de efetivar e o de mover do quadro): limites diferentes truncariam conforme a porta de entrada. -->
                        <textarea id="observacao-efetivacao" rows="5" maxlength="4000" [ngModel]="observacaoConfirmacao()" (ngModelChange)="observacaoConfirmacao.set($event)"></textarea>
                    </section>
                }
                <ng-template pTemplate="footer">
                    <div class="historico-formulario-acoes">
                        <button pButton type="button" class="p-button-text p-button-sm" label="Fechar" [disabled]="confirmandoSolicitacao()" (click)="fecharDialogAcao()"></button>
                        <button
                            pButton
                            type="button"
                            class="p-button-sm"
                            [label]="dialogAcaoSelecionada() === 'confirmar' ? 'Confirmar' : 'Cancelar solicitacao'"
                            [loading]="dialogAcaoSelecionada() === 'confirmar' && confirmandoSolicitacao()"
                            [disabled]="(dialogAcaoSelecionada() === 'confirmar' && confirmandoSolicitacao()) || !podeConfirmarAcao()"
                            (click)="confirmarDialogAcao()"
                        ></button>
                    </div>
                </ng-template>
            </p-dialog>

            @if (activeAction() === 'visualizar' && selectedCodigo() === 'pre-medico') {
                <app-pre-medico-servicos
                    [protocoloSelecionado]="protocoloSelecionado()"
                    [codigoEstado]="codigoEstado()"
                    [abaSelecionadaExterna]="abaPreMedicoSelecionadaExterna"
                    [efetivacaoJaConcluida]="crmGeradoConfirmacao() !== null"
                    (finalizarWizard)="confirmarSolicitacao.emit({})"
                ></app-pre-medico-servicos>
            }

            @if (activeAction() === 'visualizar' && selectedCodigo() === 'averbacao-nome') {
                <app-averbacao-nome-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()" (dataHoraSolicitacaoAtualizada)="onDataHoraSolicitacaoAtualizada($event)"></app-averbacao-nome-servicos>
            }

            @if (activeAction() === 'visualizar' && selectedCodigo() === 'averbacao-nacionalidade') {
                <app-averbacao-nacionalidade-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-averbacao-nacionalidade-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'cancelamento-falecimento' || selectedCodigo() === 'cancelar-por-falecimento')) {
                <app-cancelamento-falecimento-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-cancelamento-falecimento-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'cancelamento-inscricao' || selectedCodigo() === 'cancelamento-de-inscricao')) {
                <app-cancelamento-inscricao-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-cancelamento-inscricao-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'solicitar-2via-carteira' || selectedCodigo() === 'carteira-profissional')) {
                <app-carteira-profissional-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-carteira-profissional-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'solicitar-2via-cedula-identidade' || selectedCodigo() === 'cedula-de-identidade')) {
                <app-cedula-identidade-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-cedula-identidade-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'especialidade' || selectedCodigo() === 'especialidades')) {
                <app-especialidade-medica-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-especialidade-medica-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'area-atuacao' || selectedCodigo() === 'area-de-atuacao')) {
                <app-area-atuacao-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-area-atuacao-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'pos' || selectedCodigo() === 'pos-graduacao')) {
                <app-pos-graduacao-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-pos-graduacao-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'diretor-clinico' || selectedCodigo() === 'diretoria-clinica')) {
                <app-diretor-clinico-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-diretor-clinico-servicos>
            }

            @if (activeAction() === 'visualizar' && selectedCodigo() === 'pre-prestador') {
                <app-pre-prestador-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()" [abaSelecionadaExterna]="abaPrePrestadorSelecionadaExterna"></app-pre-prestador-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'pcmso' || selectedCodigo() === 'responsavel-pcmso')) {
                <app-pcmso-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-pcmso-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'consultorio-privado' || selectedCodigo() === 'cadastro-consultorio-privado')) {
                <app-consultorio-privado-cadastro-servicos
                    [protocoloSelecionado]="protocoloSelecionado()"
                    [codigoEstado]="codigoEstado()"
                    [abaSelecionadaExterna]="abaConsultorioPrivadoSelecionadaExterna"
                    (visibilidadeAbasAlterada)="onVisibilidadeAbasConsultorioAlterada($event)"
                ></app-consultorio-privado-cadastro-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'consultorio-privado-renovacao' || selectedCodigo() === 'renovacao-consultorio-privado')) {
                <app-consultorio-privado-servicos
                    [protocoloSelecionado]="protocoloSelecionado()"
                    [codigoEstado]="codigoEstado()"
                    [abaSelecionadaExterna]="abaConsultorioPrivadoSelecionadaExterna"
                    (visibilidadeAbasAlterada)="onVisibilidadeAbasConsultorioAlterada($event)"
                ></app-consultorio-privado-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'visto-fracionado' || selectedCodigo() === 'visto-corrido')) {
                <app-visto-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-visto-servicos>
            }

            @if (activeAction() === 'visualizar' && selectedCodigo() === 'cart-evento') {
                <app-cart-eventos-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-cart-eventos-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'regimento-interno' || selectedCodigo() === 'regimento-interno-corpo-clinico')) {
                <app-regimento-interno-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-regimento-interno-servicos>
            }

            @if (activeAction() === 'visualizar' && selectedCodigo() === 'comissao-etica') {
                <app-comissao-etica-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-comissao-etica-servicos>
            }

            @if (activeAction() === 'visualizar' && selectedCodigo() === 'cancelamento-pj') {
                <app-cancelamento-pj-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-cancelamento-pj-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'alteracao-cadastral' || selectedCodigo() === 'alteracao-contratual' || selectedCodigo() === 'visto-alteracao-contratual')) {
                <app-alteracao-cadastral-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-alteracao-cadastral-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'renovacao' || selectedCodigo() === 'renovacao-servicos' || selectedCodigo() === 'renovacao-cadastral')) {
                <app-renovacao-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-renovacao-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'solicitacao-diretor' || selectedCodigo() === 'diretor-tecnico-solicitacao-pj' || selectedCodigo() === 'saida-diretor-tecnico')) {
                <app-solicitacao-diretor-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-solicitacao-diretor-servicos>
            }

            @if (activeAction() === 'visualizar' && (selectedCodigo() === 'solicitacao-diretor-tecnico' || selectedCodigo() === 'diretor-tecnico-solicitacao-pf')) {
                <app-solicitacao-diretor-tecnico-servicos [protocoloSelecionado]="protocoloSelecionado()" [codigoEstado]="codigoEstado()"></app-solicitacao-diretor-tecnico-servicos>
            }

            @if (showEmail()) {
                <app-email [visible]="showEmailDialog()" (visibleChange)="showEmailDialog.set($event)" [dadosIniciais]="dadosIniciaisEmail()" (sendEmail)="onSendEmail($event)" (goBack)="onEmailGoBack()"></app-email>
            }
        </div>
    </div>
</app-card-content>
